import { Card, Row, Col, Divider, Form, Select, Button } from "antd"
import { useState } from 'react';
import { useQuery } from 'react-query'
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';

import instructionIos from '../../assets/ios/iosInstructions.pdf'
import instructionsAndroid from '../../assets/android/androidInstructions.pdf'
import supplement from '../../assets/Ενημερωτικό ένθετο τηλεματικής συσκευής (Beacon).pdf'
import EndPoints from '../../shared/endPoints/EndPoints.json';
import useHttpClient from '../../shared/sendRequest/useHttpClient'
/* eslint-disable-next-line jsx-a11y/media-has-caption */

export default function InstallationGuide() {
    const styles = {
        video: {
            height: '100%',
            width: '100%'
        }
    }
    const [marqueId, setMarqueId] = useState(null)
    const [modelId, setModelId] = useState(null)
    const [showIosVideo, setShowIosVideo] = useState(false)
    const [showAndroidVideo, setShowAndroidVideo] = useState(false)
    const [form] = Form.useForm();
    const { sendRequest } = useHttpClient()

    const formItemLayout = {
        labelCol: {
            span: 10,
        },
        wrapperCol: {
            span: 8
        },
    };

    const { data: marques } = useQuery('getmarquesmobile', async () => sendRequest({
        endpoint: `${EndPoints.BASEURL + EndPoints.MOBILE.GETMARQUES}`,
        method: 'GET',
    }))

    const { data: versions } = useQuery(['getmodelsmobile', { marqueId }], async () => sendRequest({
        endpoint: `${EndPoints.BASEURL}${EndPoints.MOBILE.GETMODELS}?MarqueId=${marqueId}`,
        method: 'GET',
    }), { enabled: !!marqueId })

    const { data: video } = useQuery(['getvideomobile', { modelId }], async () => sendRequest({
        endpoint: `${EndPoints.BASEURL}${EndPoints.MOBILE.GETVIDEOOOOOOO}?ModelId=${modelId}`,
        method: 'GET',
    }), { enabled: !!modelId })

    return (
        <Card type="inner" style={styles.myCardStyle}>

            <Row justify="center">
                <Col xs={24} lg={12} style={{ fontWeight: 'bold' }} >
                    Οδηγίες Εγκατάστασης Εφαρμογής ShortDrive (Άδειες και Ρυθμίσεις)
                </Col>

            </Row>

            <Row justify="center">
                <Col xs={24} lg={12} >
                    <ul>
                        <li>
                            Αν το κινητό σου τηλέφωνο είναι Smart Phone (Android)   <AndroidOutlined height="100px" /> κατέβασε το αρχείο
                            <a href={instructionsAndroid} download="Οδηγίες Εγκατάστασης Εφαρμογής ShortDrive  Greece (Άδειες και Ρυθμίσεις)" > εδώ</a>
                        </li>
                        Αν θέλεις να δεις τις <span style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}>οδηγίες σε μορφή βίντεο</span> κάνε κλικ<Button type="link" onClick={() => { setShowAndroidVideo(true) }}>εδώ</Button>

                        {showAndroidVideo ?
                            <Form form={form} {...formItemLayout}>
                                <Row justify="center">
                                    <Col xs={24} lg={12}>
                                        <Form.Item name="marque" label="Μάρκα:">
                                            <Select onChange={(id) => { form.setFieldsValue({ 'version': undefined }); setMarqueId(id); }}>
                                                {marques?.map((marque) => <Select.Option key={marque.marque} value={marque.id}>{marque.marque}</Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col xs={24} lg={12}>
                                        <Form.Item name="version" label="Έκδοση Android:">
                                            <Select onChange={(id) => setModelId(id)}>
                                                {versions?.map((version) => <Select.Option key={version.version} value={version.id}>{version.version}</Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                {video ? (
                                    <Row justify="center">
                                        <Col xs={24} md={12} lg={12}>
                                            <video style={styles.video} controls >
                                                <source src={video.video} type="video/mp4" />
                                                <track kind="captions" />
                                            </video>
                                        </Col>
                                    </Row>) : null}
                            </Form> : null}

                        <li>
                            Αν το κινητό σου τηλέφωνο είναι iPhone (iOS) <AppleOutlined />, κατέβασε το αρχείο  <a href={instructionIos} download="Οδηγίες Εγκατάστασης Εφαρμογής ShortDrive  Greece (Άδειες και Ρυθμίσεις)" > εδώ</a>
                        </li>
                        Αν θέλεις να δεις τις <span style={{ fontWeight: 'bold', textDecorationLine: 'underline' }}>οδηγίες σε μορφή βίντεο</span> κάνε κλικ<Button type="link" onClick={() => { setShowIosVideo(true) }}>εδώ</Button>

                        {showIosVideo ? <Row justify="center">
                            <Col xs={24} md={12} lg={12}>
                                <video style={styles.video} controls >
                                    <source src="https://shortdrive.gr/videos/IOS.mp4" type="video/mp4" />
                                    <track kind="captions" />
                                </video>
                            </Col>
                        </Row> : null}
                    </ul>
                </Col>

            </Row>            
            <Divider />
            <Row justify="center">
                <Col xs={24} lg={12}  >
                    <a href={supplement} download="Ενημερωτικό ένθετο τηλεματικής συσκευής (beacon)" ><Col > Ενημερωτικό ένθετο τηλεματικής συσκευής (beacon)</Col ></a>
                    <embed src={supplement} width="100%" height="1700px" />
                </Col>
            </Row>
        </Card>)
}